const CURRENCY_COUNTRIES = {
  AR: "ARS",
  CL: "CLP",
};

export const DEFAULT_CURRENCY = "ARS";

export const getCurrencyByCountry = (country) =>
  CURRENCY_COUNTRIES[country] || null;
